import { useLocation } from 'react-router-dom';

export const useVersionQueryParam = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  return params.get('version');
}